import clsx from 'clsx'
import { ButtonBase } from '../Button/ButtonBase'
import { IChipProps } from './types'
import styles from './styles.module.scss'

const Chip = ({
  children,
  color = 'slate',
  id,
  onClick,
  size = 'sm',
  style,
  ...props
}: IChipProps) => {
  return (
    <div
      className={clsx('mui-chip', styles.chip, styles[color], styles[size])}
      data-testid="mui-chip"
      id={id}
      style={{ ...style }}
      {...props}
    >
      <span>{children}</span>
      {onClick !== undefined && (
        <ButtonBase onClick={() => onClick(id)} aria-label={`chip-button-${id}`}>
          <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512">
            <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
          </svg>
        </ButtonBase>
      )}
    </div>
  )
}

export default Chip
